/** @jsx jsx */
import { array, string } from 'prop-types'
import { Fragment, useEffect, useRef, useState } from 'react'
import { Text, Flex, Link, jsx } from 'theme-ui'
import { useCalendarArticle } from '../../../hooks/useCalendarArticle'

const CalendarArticleColumns = ({ columns, id }) => {
  const [scrollHeight, setScrollHeight] = useState(0)
  const ref = useRef()

  const { isOpen } = useCalendarArticle()

  useEffect(() => {
    setScrollHeight(ref.current.scrollHeight)
  }, [ref])

  return (
    <Flex
      ref={ref}
      sx={{
        maxHeight: isOpen(id) ? scrollHeight + 'px' : 0,
        overflow: 'hidden',
        transition: 'max-height 0.2s ease-out',
        flexDirection: 'column',
      }}
    >
      {columns.map(column => {
        const day = column.fields.day
        return (
          <Flex
            key={column.sys.id}
            sx={{
              width: '100%',
              display: 'grid',
              gridTemplateColumns: '0.5fr 1.25fr 1.25fr',
              position: 'relative',
            }}
          >
            <Text
              sx={{
                borderBottom:
                  (column.fields.firstColumnTitle ||
                    column.fields.secondColumnTitle) &&
                  '2px solid darkGray',
                fontSize:
                  !(
                    column.fields.firstColumnTitle ||
                    column.fields.secondColumnTitle
                  ) && 0,
              }}
            />

            <Text
              sx={{
                fontSize: '1.125rem',
                color: 'black',
                padding: '10px 0',
                borderBottom:
                  column.fields.firstColumnTitle && '2px solid darkGray',
              }}
            >
              {column.fields.firstColumnTitle && column.fields.firstColumnTitle}
            </Text>

            <Text
              sx={{
                fontSize: '1.125rem',
                color: 'black',
                padding: '10px 0',
                borderBottom:
                  column.fields.secondColumnTitle && '2px solid darkGray',
              }}
            >
              {column.fields.secondColumnTitle &&
                column.fields.secondColumnTitle}
            </Text>
            {column.fields.dayContent.map((dayContent, index) => {
              return (
                <Fragment key={dayContent.sys.id}>
                  <Text
                    sx={{
                      color: 'darkGray',
                      fontWeight: '600',
                      padding: '10px 0',
                      textAlign: 'center',
                      justifyContent: 'center',
                      borderBottom: '1px solid darkGray',
                      fontSize: index !== 0 ? '0px' : '1rem',
                    }}
                  >
                    {new Date(day).getUTCDate()}
                  </Text>
                  <Text
                    sx={{
                      color: 'darkGray',
                      fontSize: '1rem',
                      fontWeight: '500',
                      padding: '10px 0',
                      borderBottom: '1px solid darkGray',
                    }}
                    key={index}
                  >
                    {dayContent.fields.firstColumnText}
                  </Text>
                  <Text>
                    {dayContent.fields.secondColumnLink.map(link => {
                      return (
                        <Text
                          sx={{
                            color: 'forest',
                            fontSize: '1rem',
                            textDecoration: 'underline',
                            padding: '10px 0',
                            '&:last-child': {
                              borderBottom: '1px solid darkGray',
                            },
                          }}
                          key={link.sys.id}
                        >
                          {link.fields.slug ? (
                            <Link
                              href={link.fields.slug}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.fields.title}
                            </Link>
                          ) : (
                            <Link
                              href={link.fields.file.fields.file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {link.fields.title}
                            </Link>
                          )}
                        </Text>
                      )
                    })}
                  </Text>
                </Fragment>
              )
            })}
          </Flex>
        )
      })}
    </Flex>
  )
}

CalendarArticleColumns.propTypes = {
  columns: array,
  id: string,
}

export default CalendarArticleColumns
